
(function () {
    angular.module('tmx-app').controller('accountOpeningApplicationCtrl', ['$state', 'LoanApplicationService', 'AccountApplicationService',
        '$mdSidenav','cacheStore','lookupService', 'resolvedData', 'tmxUtility', 'menu', 'tmxResource', 'TmxDialogService', 'ToastService', '$filter', 'LoanProductService', '$mdDialog','TMX_FINANCE_CONSTANTS',
        function AccountOpeningApplicationCtrl($state, LoanApplicationService, AccountApplicationService, 
            $mdSidenav,cacheStore,lookupService, resolvedData, tmxUtility, menu, tmxResource, TmxDialogService, ToastService, $filter, LoanProductService, $mdDialog,TMX_FINANCE_CONSTANTS) {

            //#region ------Dev Notes---------------

            //#endregion

            //#region -----Variables Declaration and Initialization-----
            var vm = this;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            vm.formatDate = tmxUtility.formatDateForCompany;
            vm.checkPermission = tmxUtility.checkPermission;
            vm.menu = menu;
            vm.isPageLoading = false;
            vm.gridData = new kendo.data.ObservableArray([]);
            vm.date = new Date().toJSON();
            vm.nav = "SearchSideNav";
            vm.schema = LoanApplicationService.schema;
            vm.cloneColumn = AccountApplicationService.gridColumns;
            vm.LoanApplicationService = LoanApplicationService;
            vm.LoanProducts = resolvedData.loanProducts.data;
            vm.userBanches = resolvedData.userBranches.data;
            vm.gridColumns = AccountApplicationService.gridColumns;
            vm.Columns = AccountApplicationService.gridColumns;
            var LoanApplicationStatus = resolvedData.LoanStatus;
            vm.filterChips = [];
            var previousSelectedChip = null;
            vm.gridColumns[0].template = formatApplicationName;

            vm.editPermission=vm.checkPermission('Private.Transaction.AccountOpeningApplication','Edit');
            vm.entityPermission=vm.checkPermission('Private.Transaction.AccountOpeningApplication','View Entity');

            // var culture=kendo.culture(); // To be handled by configurations
            // culture.numberFormat.currency.symbol = "PKR. ";

            //#endregion

            //#region  ------Private Functions -----------

            function InitializeGrid() {
                vm.filters = {};
                vm.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function (o) {

                                if (angular.isDefined(vm.searchClear) && vm.searchClear == false) {
                                    if (exists(vm.o)) {
                                        copy(vm.o.data, ["filter"], o.data);
                                    }
                                }
                                vm.searchClear = false;
                                if (vm.onChildState()) { return; }
                                if (!o.fromSideNav) {
                                    if ($state.searchClear) {
                                        vm.searchClear = true;
                                        $state.searchClear = undefined;
                                        //return;
                                    }
                                    //if(exists(vm.o))
                                    //    copy(vm.o.data,["filter"],o.data);
                                }
                                else {
                                    o.data.firstPage = true;
                                }


                                vm.o = angular.copy(o);
                                vm.filters = vm.o.data.filter;
                                vm.isPageLoading = true;
                                // LoanApplicationService.getByAction("",true).then(function(response){
                                tmxResource("AccountApplication/List").getByParams(o, true).then(function (response) {
                                    parseResppnse(response.data);
                                    vm.exportData=response;
                                    o.success(response);
                                    vm.isPageLoading = false;
                                });
                            },

                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },

                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        sort: [{ field: "AccountApplicationId", dir: "desc" }]
                    },
                    excelExport: function(e) {                                         
                        var sheet = e.workbook.sheets[0];
                        var data = vm.exportData.data;
                        var gridColumns = vm.container.LoanApplicationGrid.columns;                    
                        var columns = tmxUtility.columnsMapping(gridColumns);                    
                        var rows=tmxUtility.dataMapping(data,columns);
                        sheet.rows = rows;  
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: true,
                        pageSize: 10,
                        buttonCount: 5,
                        /*  messages: {
                              itemsPerPage: "Rows per page",
                              display: "{2} Rows found, displaying {0}-{1}. ",
                              empty: "0 Rows found."
                          },*/

                    },
                    pdf: {
                        allPages: true,
                        fileName: "AccountApplications.pdf"
                    },
                    excel: {
                        /*  allPages: true,*/
                        fileName: "AccountApplications.xlsx"
                    },

                    sortable: true,
                    scrollable: false,

                    ///   rowTemplate: "<tr data-uid='#= uid #' ><td><md-button class='tmx-primary-text'  > \{\{LoanApplicationCtrl.formatAccountApplicationId(dataItem)\}\}   <md-tooltip md-direction='top'>#=AccountApplicationId#</md-tooltip>  </md-button></td><td> \{\{LoanApplicationCtrl.formatRequestedLoanAmount(dataItem)\}\} </td><td> \{\{LoanApplicationCtrl.formatApprovedLoanAmount(dataItem)\}\} </td><td> \{\{LoanApplicationCtrl.formatTotalRecieiveableAmount(dataItem)\}\} </td><td> \{\{LoanApplicationCtrl.formatInstallmentAmount(dataItem)\}\}   </td><td> \{\{LoanApplicationCtrl.formatStatus(dataItem)\}\}   </td><td> \{\{LoanApplicationCtrl.formatDate(dataItem)\}\}   </td><td> \{\{LoanApplicationCtrl.formatDate(dataItem)\}\}   </td><td><md-menu flex='none' class='menu-list-item' ><md-button  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button><md-menu-content width='2' ><md-menu-item><md-button aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>info</md-icon>Device Info</md-button></md-menu-item><md-menu-item ng-if='!DeviceManagementCtrl.isStatusActive(dataItem) && DeviceManagementCtrl.notPending(dataItem)'><md-button  aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickInactive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate Device</md-button></md-menu-item><md-menu-item ng-if='DeviceManagementCtrl.isStatusActive(dataItem)'><md-button  aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickActive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>check_circle</md-icon>Activate Device</md-button></md-menu-item></md-menu-content></md-menu></td></tr>",

                    columns: vm.gridColumns
                };
                vm.searchSideNavActive = false;
                //////////INITIALIZING THE $state.data for access to grid in Edit.js///////////////////////////////////////////////
                vm.container = {};//defining the object for grid access in controller
                $state.data = {
                    grid: vm.container,
                    mainGridOptions: angular.copy(vm.mainGridOptions)
                };
            }

            function PrepareLovs(){
                if(tmxUtility.exists(resolvedData.productTypesLkp)){
                    let accountProductLkpIds = resolvedData.productTypesLkp.filter(x=>x.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.AccountProduct).map(x=> x.LookupId);
                    vm.LoanProducts = vm.LoanProducts.filter(product =>  accountProductLkpIds.includes(product.ProductTypeLkp));
                }
                PrepareFilterChips();
            }

            function PrepareFilterChips(){
                let roleStatusLookups = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ROLE_STATUS_MAPPING);
                let loggedinUserInfo = cacheStore.get('GetInfoOfLoggedInUser');
                if(!exists(loggedinUserInfo)){
                    return;
                }
                let roleStatusMappingItem = roleStatusLookups.find(x=>x.HiddenValue.toLowerCase() == loggedinUserInfo.RoleName.toLowerCase());
                if(!exists(roleStatusMappingItem)){
                    return;
                }          
                vm.filterChips = roleStatusMappingItem.Description.split(',').map(x=>({Name:x.trim(),Style:'default'}));
                if(vm.filterChips.length > 0){
                    vm.filterChips.unshift({Name:'All',Style:'active'}); // Add 'All' on the begining of the array
                    previousSelectedChip = 'All';
                }
            }

            function parseResppnse(data){
                data.forEach(function(dataItem){                                                                            
                    dataItem.CustomerName= vm.formatCustomerName(dataItem.CustomerName);    
                    dataItem.NationalIdentifierValue=vm.formatCNICNumber(dataItem.NationalIdentifierValue);   
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);   
                    dataItem.CustomerCode=vm.formatCustomerCode(dataItem.CustomerCode);
                    dataItem.CustomerAccountNumber=vm.formatString(dataItem.CustomerAccountNumber);
                    dataItem.CreatorName =vm.formatUser(dataItem.CreatorName);
                    dataItem.InboxName =vm.formatUser(dataItem.InboxName);
                    dataItem.formattedAccountopeningrequestdate =vm.formatDate(dataItem.accountopeningrequestdate);
                });      
                
                vm.deletePermission=vm.checkEntityPermission("Delete");
                vm.assignPermission=vm.checkEntityPermission("Assign");
            }

            //#endregion

            //#region  ---------Scope Functions -----------

            vm.checkEntityPermission = function (privilegeName) {
                return vm.checkPermission('Private.Transaction.AccountOpeningApplication', privilegeName);
            }

            vm.getMenu = function () {
                if (angular.isDefined(menu.pages.sections)) {
                    for (var i = 0; i < menu.pages.sections.length; i++) {
                        var section = menu.pages.sections[i];
                        if (angular.isDefined(section.pages) && section.pages != null && section.pages.length > 0) {
                            for (var j = 0; j < section.pages.length; j++) {
                                if (section.pages[j].name == vm.EntityName) {
                                    return section.pages[j];
                                }
                            }
                        }
                    }
                }
                return undefined;
            };

            vm.getLookupName = function (ApplicationStatusLkpId) {
                var result = "N/A";
                if (!angular.isArray(LoanApplicationStatus)) {
                    return result;
                }
                LoanApplicationStatus.forEach(function (loanAppStatusLookup) {

                    if (loanAppStatusLookup.HiddenValue == ApplicationStatusLkpId) {
                        result = loanAppStatusLookup.VisibleValue;
                    }
                });
                return result;
            }

            vm.gotoAdd = function (productId, branchId) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name + ".add", { Id: productId, branchId: branchId, callbackState: $state.current.name });
            }

            vm.onChildState = function () {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            }

            vm.goToEdit = function (application) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                var id = application.AccountApplicationId;
                $state.go($state.current.name + ".edit", { Id: id, callbackState: $state.current.name });
            }
            vm.goToEditId = function (id) {
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name + ".edit", { Id: id, callbackState: $state.current.name });
            }


            vm.isOpen = function (navID) {
                return $mdSidenav(navID).isOpen();
            };

            vm.clickDelete = function (item) {
                var deleteApplication = function (item) {
                    AccountApplicationService.CancelById(item.accountApplicationID).then(function () {
                        $('#grid').data('kendoGrid').dataSource.read();
                    })
                };

                let messageText = 'Are you sure you want to cancel this Account Application?';
                let messageTitle = `Cancel Account Application ${item.AccountApplicationNumber} ?`
                TmxDialogService.showConfirmDialog(messageTitle, messageText, function () {
                    deleteApplication(item)
                });
            };

            vm.clickAdd = function () {
                $mdDialog.show({
                    controller: ['$mdDialog', '$scope', 'tmxUtility', 'products', 'branches', productSelectionController],
                    locals: {
                        products: vm.LoanProducts,
                        branches: vm.userBanches
                    },
                    templateUrl: 'app/private/transaction/product-selection-dialog.html',
                    clickOutsideToClose: false,
                    fullscreen: true

                }).then(function (returnData) {
                    if (!tmxUtility.exists(returnData)) {
                        return;
                    }
                    vm.gotoAdd(returnData.ProductId, returnData.BranchId);
                });
            }

            vm.clickAssign = function (item) {
                LoanProductService.getStatesbyProduct(item.ProductId).then(function (response) {

                    $mdDialog.show({
                        controller: ['$mdDialog', '$scope', 'tmxUtility', 'lookupService', 'TMX_FINANCE_CONSTANTS', 'data', 'states', assignController],
                        locals: {
                            data: item,
                            states: response.data
                        },
                        templateUrl: 'app/private/transaction/assign-dialog.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        fullscreen: true
                    }).then(function (returnData) { // After closing the dialog
                        if (!tmxUtility.exists(returnData)) {
                            return;
                        }
                        let data = returnData;
                        data.ProcessId = item.ProcessInstanceID;
                        data.ApplicationId = item.accountApplicationID;
                        data.PreviousStatusLkp = item.ApplicationStatusLkp;
                        AccountApplicationService.setApplicationState(data).then(function (result) {
                            if (result.data && result.status.code == "200") {
                                ToastService.showCustomToast("success", $filter('translate')("StateChangeSuccess"));
                                $('#grid').data('kendoGrid').dataSource.read();
                                return;
                            }
                            ToastService.showCustomToast("error", $filter('translate')("StateChangeError"));
                        });

                    }, function () {

                    });
                });
            }

            vm.onChipClick = function(selectedChip){
                if(previousSelectedChip == selectedChip.Name){
                    return;
                }
                previousSelectedChip = selectedChip.Name;
                vm.filterChips.forEach(x=>x.Style ='default');
                selectedChip.Style = 'active';

                if(exists(vm.o.data.filter)){
                    // If there is previous filter applied then remove the 'Status' Filter
                    vm.o.data.filter.filters =vm.o.data.filter.filters.filter(x=>x.field != 'Status');
                }
                else {
                    //Initialize the filters
                    vm.o.data.filter = {
                        filters:[],
                        logic:'and'
                    }
                }
                if(selectedChip.Name.toLowerCase() != 'all'){
                    var chipFilter = {
                        field:'Status',
                        operator:'contains',
                        value:selectedChip.Name
                    }
                    vm.o.data.filter.filters.push(chipFilter);
                }
                vm.container.LoanApplicationGrid.dataSource.transport.read(vm.o);
            }

            //*******************KENDO*********************//

            vm.isFiltered = function (fieldName) {
                var filtered = false;
                if (angular.isDefined(vm.filters)) {
                    vm.filters.filters.forEach(function (filter) {
                        if (filter.field == fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }       

            function formatApplicationName(item) {
                var id = item.accountApplicationID;
                var template = '<md-button class="tmx-primary-text-grid" ng-disabled="!AccountOpeningApplicationCtrl.editPermission || !AccountOpeningApplicationCtrl.entityPermission" ng-click="AccountOpeningApplicationCtrl.goToEditId(' + id + ')">' + item.AccountApplicationNumber + '</md-button> <div class="margin-bottom-2"> <span class="chip" ng-style={{dataItem.StatusBKColor}}> '+item.Status+ '</span> </div>';
                return template;
            }

            vm.formatCustomerName = function (dataitem) {
                return dataitem;
            };
            vm.formatCustomerCode = function (custCode) {
                if (!custCode || custCode === "0") return '';
                return custCode;
            };
            vm.formatCNICNumber = function (dataitem) {
                if (!dataitem) return "";
                return dataitem;
            };

            vm.formatString = function (value) {
                if (!value) {
                    return "";
                }
                else {
                    return value;
                }
            };

            vm.toggleSearch = function () {
                if (vm.searchSideNavActive) {
                    vm.searchData = {};
                    vm.searchSideNavActive = false;
                }
                else
                    vm.searchSideNavActive = true;
                vm.toggle('SearchSideNav');
            }
            vm.exportSideNavActive = false;

            vm.toggleExport = function () {
                if (vm.exportSideNavActive)
                    vm.exportSideNavActive = false;
                else
                    vm.exportSideNavActive = true;
                vm.toggle('ExportSideNav');
            }

            vm.toggle = function (navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                    });
            };

            vm.filt = {};


            vm.search = function (navID) {
                let calls = [];

                for (var key in vm.searchData) {
                    if (vm.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: vm.searchData[key]
                        });
                    }
                }

                vm.filt = {
                    filters: calls,
                    logic: "and"
                };
                vm.o.data.filter = vm.filt;
                vm.container.LoanApplicationGrid.dataSource.transport.read(vm.o);

                vm.searchData = {};
                vm.toggle(navID);
            };

            vm.clear = function (navID) {
                vm.searchData = {};
                vm.toggle(navID);
            };


            /// Formating
            vm.formatLoanAmount = function (Amount) {
                if (Amount <= 0) {
                    return "N/A";
                }
                else {
                    return Amount;

                }
            }

            vm.formatUser=function(value){
                if(!value) {
                    return " ";
                }
                else {
                    return value;
                }                        
            };

            vm.formatTenure = function (Tenure) {
                if (parseInt(Tenure, 10) <= 0) {
                    return "N/A";
                }
                else {
                    return Tenure;

                }
            }
            //#endregion

            //#region  --Child Controllers-----

            function assignController($mdDialog, $scope, tmxUtility, lookupService, TMX_FINANCE_CONSTANTS, data, states) {

                $scope.availableStates = [];
                $scope.availableStatuses = [];
                $scope.data = data;
                $scope.showLoanEditableFields = false;

                $scope.ok = function () {

                    $scope.assignDialogCtrl.dialogForm.$submitted = true;
                    if (!$scope.assignDialogCtrl.dialogForm.$valid) {
                        return;
                    }
                    let returnData = {
                        State: $scope.selectedState,
                        ApplicationStatusLkp: $scope.selectedStatus,
                        Comments: $scope.comments
                    }
                    $mdDialog.hide(returnData);
                }

                $scope.cancel = function () {
                    $mdDialog.hide();
                }


                function InitializeData() {
                    if (tmxUtility.exists(states) && states.length > 0) {
                        $scope.availableStates = states.filter(x => x.Name.trim() != "")
                            .map(x => ({
                                HiddenValue: x.Name,
                                VisibleValue: x.VisibleName
                            }));
                    }

                    $scope.availableStatuses = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.APPLICATION_STATUS);

                    $scope.availableStates = tmxUtility.orderArrayByProperty($scope.availableStates, ['VisibleValue'], ['asc']);
                    $scope.availableStatuses = tmxUtility.orderArrayByProperty($scope.availableStatuses, ['VisibleValue'], ['asc']);

                }

                (function InitializePage() {
                    InitializeData();
                })();
            }

            function productSelectionController($mdDialog, $scope, tmxUtility, products, branches) {
                $scope.availableProducts = [];
                $scope.userBranches = [];
                $scope.disableBranchSelection = false;


                $scope.ok = function () {

                    $scope.productSelectionCtrl.dialogForm.$submitted = true;
                    if (!$scope.productSelectionCtrl.dialogForm.$valid) {
                        return;
                    }
                    let returnData = {
                        ProductId: $scope.selectedProduct,
                        BranchId: $scope.selectedBranch
                    }
                    $mdDialog.hide(returnData);
                }

                $scope.cancel = function () {
                    $mdDialog.hide();
                }

                function InitializeData() {
                    $scope.availableProducts = products.map(x => ({ LookupId: x.ProductId, VisibleValue: x.ProductName }));
                    if (tmxUtility.exists(branches)) {
                        $scope.userBranches = branches.map(x => ({ LookupId: x.CompanyBranchId, VisibleValue: x.BranchName }));
                        if ($scope.userBranches.length == 1) { // If there is only one branch associated, then by default make it selected and disabled
                            $scope.selectedBranch = $scope.userBranches[0].LookupId;
                            $scope.disableBranchSelection = true;
                        }
                    }
                }

                (function InitializeDialog() {
                    InitializeData();
                })();
            }

            //#endregion

            // eslint-disable-next-line no-unexpected-multiline
            (function InitializePage() {
                InitializeGrid();
                PrepareLovs();
            })();
        }
    ]);
})();

